import React, { useContext } from 'react';
import TopCardsExpert from '../../Expert/Dashboard/TopCardsExpert';
import TopCardsUser from '../../User/Dashboard/TopCardsUser';
import { ProfileContext } from '../../Contexts/contexts';

function TopCards() {
	const contextData = useContext(ProfileContext);

	if (contextData && contextData.isClient) {
		return (
			<>
				<TopCardsUser />
			</>
		);
	} else {
		return (
			<>
				<TopCardsExpert />
			</>
		);
	}
}

export default TopCards;
